import { render, staticRenderFns } from "./offline_aftersale_list.vue?vue&type=template&id=22043f87&scoped=true"
import script from "./offline_aftersale_list.vue?vue&type=script&lang=js"
export * from "./offline_aftersale_list.vue?vue&type=script&lang=js"
import style0 from "./offline_aftersale_list.vue?vue&type=style&index=0&id=22043f87&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22043f87",
  null
  
)

export default component.exports